import { normalizeRut } from '@/utils/rut';
import type { ValidatedCreateEmployeeFormData, LC_CreateEmployeeIn } from '../types';

/**
 * Mapea los datos del formulario UI (ya validados por Zod) al formato de transporte para el backend
 * - Separa RUT en cuerpo (rut) y dígito verificador (dv)
 * - Convierte birthDate de yyyy-mm-dd a formato ISO 8601
 * - Mapea employmentStatus a employmentStatusCode
 * - Convierte strings vacíos a null para campos opcionales
 */
export function mapCreateEmployeeFormToTransport(
  formData: ValidatedCreateEmployeeFormData,
): LC_CreateEmployeeIn {
  // Normalizar RUT y separar en cuerpo + dv
  const normalizedRut = normalizeRut(formData.rutComplete);
  const rut = normalizedRut.slice(0, -1); // Todos menos el último carácter
  const dv = normalizedRut.slice(-1).toUpperCase(); // Último carácter (DV)

  // Convertir birthDate de yyyy-mm-dd a ISO 8601 UTC (sin depender de zona horaria local)
  const [year, month, day] = formData.birthDate.split('-').map(Number);
  const dateObject = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
  const birthDateFormatted = dateObject.toISOString();

  return {
    rut,
    dv,
    firstNames: formData.firstNames.trim(),
    lastName: formData.lastName.trim(),
    secondLastName: formData.secondLastName?.trim() || null,
    birthDate: birthDateFormatted,
    genderCode: formData.genderCode,
    maritalStatusCode: formData.maritalStatusId,
    employmentStatusCode: formData.employmentStatus,
    corporateEmail: formData.corporateEmail.trim(),
    personalEmail: formData.personalEmail.trim(),
    companyPhoneNumber: formData.companyPhoneNumber?.trim() || null,
    personalPhoneNumber: formData.personalPhoneNumber?.trim() || null,
    address: formData.address?.trim() || null,
    regionId: formData.regionId || null,
    communeId: formData.communeId || null,
    workAddress: formData.workAddress?.trim() || null,
    workRegionId: formData.workRegionId || null,
    workCommuneId: formData.workCommuneId || null,
    doesNotSync: formData.doesNotSync,
  };
}
